import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBar, MessageBarType } from '@fluentui/react';
/**
 * A prestyled inline error messagebar to make all of MSRC's forms look and feel the same.
 *
 * This is intended to live at the top of a form just below the header & subtitle.
 */
export const FormError = (props) => {
    if (!props.children) {
        return null;
    }
    return _jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.error }, props));
};
